import { addUnitMembers, deleteUnitMember, getUnitMembers } from "../../../api/unit/members";
import { Button } from "../../Button";
import { ConfirmationModal } from "../../ConfirmationModal";
import { default as convertStringToColor } from "../../../helpers/util/convertStringToColor";
import { getAvailableUnitMembers } from "../../../api/unit/members";
import { getUserProfile } from "../../../api/user/profile";
import { Role } from "../../../constants/role";
import { MemberCard } from ".";
import { PropTypes } from "prop-types";
import { QueryLoader } from "../../Loader";
import { Search } from "../../Search";
import { Select } from "../../Select";
import { SelectableMultiplePeople } from "../../SelectableLists/SelectablePeople";
import { StyledField } from "../../../styles/StyledField";
import { StyledModal, StyledPeopleModal } from "../../../styles/StyledModal";
import { StyledUnitMembersContainer, StyledUnitMembersHeader, StyledUnitMembersList } from "../../../styles/StyledUnit/StyledContent";
import useCurrentUser from "../../../hooks/useCurrentUser";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import AddIcon from "../../../assets/img/icons/add.svg";
import Modal from "react-modal";
import ModalHeader from "../../ModalHeader/ModalHeader";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

export default function UnitMembers({ id }) {
	const { isOrgAdmin, can } = useCurrentUser();
	const { axiosPrivate } = useAxiosPrivate();

	const [openDropdowns, setOpenDropdowns] = useState({});
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [addModalIsOpen, setAddModalIsOpen] = useState(false);
	const [deletedId, setDeletedId] = useState(null);
	const [roleValue, setRoleValue] = useState(null);
	const [phrase, setPhrase] = useState(null);
	const { isLoading, isError, error, data, refetch } = useQuery(["membersTab", id, phrase], () => getUnitMembers(axiosPrivate, id, phrase));
	const { data: profile } = useQuery("userProfile", () => getUserProfile(axiosPrivate));
	// Organization admins and the unit's admins manage its members; a unit admin cannot change their own membership
	const canManageMembers = can("manageUnit", id);
	const [result, setResult] = useState([]);

	const [choosenPeople, setChoosenPeople] = useState({});


	useEffect(() => {
		if (!isLoading && !isError) {
			// Every member has the "member" role, so the "Member" filter shows the members who are not unit admins
			const hasRole = (e) => (roleValue === Role.member ? !e.roles.includes(Role.admin) : e.roles.includes(roleValue));
			const filtered = roleValue ? data.filter(hasRole) : data;
			// Unit admins first, then the other members
			const isUnitAdmin = (e) => (e.roles.includes(Role.admin) ? 0 : 1);
			setResult([...filtered].sort((a, b) => isUnitAdmin(a) - isUnitAdmin(b)));
			for (const member of data) {
				setOpenDropdowns({ ...openDropdowns, [`p${member.id}`]: false });
			}
		}
	}, [isLoading, roleValue, data]);

	const handleDelete = async (userId) => {
		await deleteUnitMember(axiosPrivate, refetch, id, userId);
	};

	if (isError) {
		console.log(error);
		refetch();
	}

	const handlePost = async () => {
		const users = [];
		for (const key in choosenPeople) {
			if (choosenPeople[key]) users.push(parseInt(choosenPeople[key].id));
		}
		setAddModalIsOpen(false);
		await addUnitMembers(axiosPrivate, refetch, id, { roles: [Role.member], users: [...users] });
	};

	return (
		<>
			<StyledUnitMembersContainer>
				<StyledUnitMembersHeader>
					<StyledField mb="12px" edit>
						<label>Role</label>
						<Select
							options={[
								{ value: null, label: "All" },
								{ value: Role.admin, label: "Unit admin" },
								{ value: Role.member, label: "Member" },
							]}
							value={roleValue}
							setMatterId={setRoleValue}
							id="role"
							name="role"
							data-testid="role"
							isBig
						/>
					</StyledField>
					<Search isWhite setPhrase={setPhrase} />
				</StyledUnitMembersHeader>
				{isLoading && <QueryLoader />}
				<StyledUnitMembersList>
					{!isLoading &&
						!isError &&
						(result.length > 0 ? (
							result.map((e, i) => (
								<MemberCard
									key={i}
									data={e}
									color={convertStringToColor(e.user.firstName + e.user.lastName)}
									openDropdowns={openDropdowns}
									setOpenDropdowns={setOpenDropdowns}
									direction={"left"}
									moreActionsPosition={"absolute"}
									openModal={(id) => {
										setDeletedId(id);
										setModalIsOpen(true);
									}}
									refetch={refetch}
									showOptions={canManageMembers && (isOrgAdmin || e.user.id !== profile?.id)}
								/>
							))
						) : (
							<h6>No members found</h6>
						))}
				</StyledUnitMembersList>
				{canManageMembers && (
					<Button
						icon={AddIcon}
						onClick={() => {
							setAddModalIsOpen(true);
						}}
					>
						Add member
					</Button>
				)}
			</StyledUnitMembersContainer>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={() => setModalIsOpen(false)}
				style={StyledModal}
				appElement={document.getElementById("app")}
			>
				<ConfirmationModal handleDelete={handleDelete} deletedId={deletedId} closeModal={() => setModalIsOpen(false)} />
			</Modal>
			<Modal
				isOpen={addModalIsOpen}
				onRequestClose={() => setAddModalIsOpen(false)}
				style={StyledPeopleModal}
				appElement={document.getElementById("app")}
			>
				<ModalHeader
					onClick={() => {
						setAddModalIsOpen(false);
					}}
				>
					Add member
				</ModalHeader>
				<SelectableMultiplePeople
					id={id}
					refetch={refetch}
					choosenPeople={choosenPeople}
					setChoosenPeople={setChoosenPeople}
					fetchPeople={getAvailableUnitMembers}
				>
					<div className="action-buttons">
						<Button
							onClick={() => {
								setAddModalIsOpen(false);
							}}
							bg={false}
							small={true}
						>
							Cancel
						</Button>
						<Button
							icon={AddIcon}
							onClick={() => {
								handlePost();
							}}
						>
							Add member
						</Button>
					</div>
				</SelectableMultiplePeople>
			</Modal>
		</>
	);
}

UnitMembers.propTypes = {
	id: PropTypes.string,
};
